import { Component, OnDestroy, AfterViewInit, EventEmitter, Input, Output, OnInit, OnChanges } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { SelectImageModalComponent } from './img-upload/select-image-modal.component';
import { InsertEmojiComponent } from './insert-emoji/insert-emoji.component';
import { MediaUploadComponent } from './media-upload/media-upload.component';
import { TinymceService } from './tinymce.service';
declare var tinymce;
@Component({
    selector: 'clink-tinymce',
    template: `<textarea id="{{ mySelector }}"></textarea>`,
})
export class TinymceComponent implements OnChanges, OnDestroy, AfterViewInit {
    @Input() key; // 解决reuse回显失效的问题
    @Input() mySelector = 'tinet-tinymce'; // id 需要动态传进来,以应对一个页面多个编辑器
    @Input() myModel;
    @Input() uploadUrl;
    @Output() myModelChange = new EventEmitter();
    @Output() maxlimit: EventEmitter<any> = new EventEmitter();
    @Input() file;
    @Input() linkAssume = false; // 是否提示加http:// https:// 前缀
    @Input() isClear; // 是否清除样式
    @Input() height = 650; // 高度
    @Input() width = '100%'; // 宽度
    @Input() toolbarMode = 'floating'; // 工具栏模式
    @Input() toolbar = [
        'toc | uploadImg | link | bullist numlist | forecolor backcolor |formatselect | fontsizeselect | fontselect ',
        ' bold italic underline strikethrough | alignleft aligncenter alignjustify alignright lineheight | undo redo importWord | table tabledelete',
    ]; // toolbar 功能列表
    @Input() plugins = [
        'toc advlist anchor autolink autosave code codesample directionality lineheight emoticons fullscreen hr image importcss insertdatetime link lists nonbreaking noneditable pagebreak preview print save searchreplace spellchecker tabfocus table template textpattern visualblocks visualchars wordcount media',
    ];
    hasChange = false;
    hasInit = false;
    initSuccess = false; // 初始化成功
    constructor(private modal: NzModalService, private tinymceService: TinymceService) {}

    // 在一个页面渲染多个tinymce 需要用不同的selector，并且把init方法写在ngAfterViewInit中
    ngAfterViewInit(): void {
        this.init();
    }

    init(): void {
        const _this = this;
        tinymce.init({
            selector: `#${_this.mySelector}`,
            base_url: '/assets/tinymce',
            // 去除自动添加的p标签
            forced_root_block: '',
            // 功能列表页
            menubar: false,
            // 右下角推广
            branding: false,
            toolbar_mode: _this.toolbarMode,
            language: 'zh_CN',
            // 区块列表
            block_formats: 'Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5;Heading 6=h6;',
            plugins: _this.plugins,
            // 功能区
            toolbar: _this.toolbar,
            paste_as_text: _this.isClear,
            link_assume_external_targets: _this.linkAssume,
            // 编辑器宽高
            height: _this.height,
            width: _this.width,
            elementpath: false,
            resize: false,
            min_height: 200,
            // 字体大小
            fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
            // 表格
            table_toolbar: 'table tabledelete | tableinsertcolbefore tableinsertcolafter tabledeletecol',
            // 字体列表
            font_formats:
                '微软雅黑=微软雅黑,Microsoft YaHei;宋体=宋体,SimSun;黑体=黑体, SimHei;隶书=隶书, SimLi;楷体=楷体,楷体_GB2312, SimKai;andale mono=andale mono;arial=arial, helvetica,sans-serif;arial black=arial black,avant garde;comic sans ms=comic sans ms;impact=impact,chicago;Arial=Arial;Verdana=Verdana;Georgia=Georgia;Times New Roman=Times New Roman;Trebuchet MS=Trebuchet MS;Courier New=Courier New;Impact=Impact;Comic Sans MS=Comic Sans MS;Calibri=Calibri',
            importcss_append: true,
            convert_urls: false,
            media_live_embeds: true,
            setup: (editor) => {
                // 自定义上传图片
                editor.ui.registry.addButton('uploadImg', {
                    icon: 'gallery',
                    tooltip: '上传图片',
                    onAction: () => {
                        const config = SelectImageModalComponent.config,
                            preData = JSON.parse(JSON.stringify(config.nzComponentParams.data));
                        config.nzComponentParams.data = { uploadUrl: _this.uploadUrl, file: this.file };
                        // config.data = { uploadUrl: _this.uploadUrl, file: this.file}
                        let modal = this.modal.create(config);
                        modal.afterClose.subscribe((result: any) => {
                            if (result && result !== 'cancel') {
                                result.forEach((element) => {
                                    if (this.file === 'file') {
                                        editor.insertContent(`<img class="wscnph" src="${element.result.fileUrl}" >`);
                                    } else {
                                        editor.insertContent(`<img class="wscnph" src="${element.result[0]}" >`);
                                    }
                                });
                            }
                            config.nzComponentParams.data = preData;
                            modal = null;
                        });
                    },
                });
                // 自定义图标
                editor.ui.registry.addButton('insertEmoji', {
                    tooltip: '插入表情',
                    icon: 'emoji',
                    onAction: () => {
                        const config = InsertEmojiComponent.config;
                        config.nzComponentParams.data = { uploadUrl: _this.uploadUrl, file: this.file };
                        const modal = this.modal.create(config);
                        modal.afterClose.subscribe((result: any) => {
                            if (result) {
                                editor.insertContent(
                                    `<img src="/assets/images/blank.gif" alt="${result}" style="display: inline-block; width: 24px !important; height: 24px; background-position: ${this.tinymceService.emojiPosition[result]}; background-repeat: no-repeat; background-image: url(/assets/images/emoji.png); margin: 0px 5px;">`,
                                );
                            }
                        });
                    },
                });
                // 自定义上传视频
                editor.ui.registry.addButton('uploadVideo', {
                    tooltip: '插入视频',
                    icon: 'embed',
                    onAction: () => {
                        const config = MediaUploadComponent.config;
                        config.nzComponentParams.data = { uploadUrl: _this.uploadUrl, file: this.file };
                        const modal = this.modal.create(config);
                        modal.afterClose.subscribe((res: Array<string>) => {
                            if (res && res.length) {
                                res.forEach((e) => {
                                    // 直接插入video标签只会插入占位图片
                                    editor.insertContent(
                                        `<span class="mce-preview-object mce-object-video" contenteditable="false" data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" data-mce-p-frameborder="no" data-mce-p-scrolling="no" data-mce-p-src=${e} data-mce-html="%20">
                                        <video [vgMedia]="media" #media id="singleVideo" preload="auto" controlsList="nodownload"  controls style="max-width: 100%;">
                                        <source src="${e}" type="video/mp4">
                                      </video></span>`,
                                    );
                                });
                            }
                        });
                    },
                });
            },
            init_instance_callback: (editor) => {
                this.initSuccess = true;
                if (this.myModel) {
                    editor.setContent(this.myModel);
                }
                this.hasInit = true;
                editor.on('NodeChange Change KeyUp SetContent', () => {
                    this.hasChange = true;
                    this.myModelChange.emit(editor.getContent());
                    // 快捷回复
                    if (this.mySelector === 'tinet-reply') {
                        if (this.getText(editor.getContent()).length > 600) {
                            this.maxlimit.emit(true);
                        } else {
                            this.maxlimit.emit(false);
                        }
                    }
                });
            },
        });
    }

    ngOnChanges(event): void {
        // 初始化之后设置内容 (只触发一次)
        if (
            this.hasInit &&
            (!this.hasChange || (event.myModel && event.myModel.previousValue + '{linkUrl}' === event.myModel.currentValue))
        ) {
            tinymce.get(this.mySelector).setContent(this.myModel);
        }
        if (this.hasInit && event.key) {
            // 每次tab切换,把当前的tinymce实例干掉重来...这玩意是真的恶心
            tinymce.remove('#' + this.mySelector);
            this.init();
        }
    }

    ngOnDestroy(): void {
        tinymce.remove('#' + this.mySelector);
    }
    getText(str): string {
        return str.replace(/<\/?[^>]*>/g, '').replace(/&nbsp;/gi, '');
    }

    handleStr(str): string {
        return str
            ? str.replace(/&((g|l|quo)t|#39|nbsp|ldquo|rdquo|amp);/g, (m) => {
                  return {
                      '&lt;': '<',
                      '&quot;': '"',
                      '&gt;': '>',
                      '&#39;': "'",
                      '&nbsp;': ' ',
                      '&ldquo;': '“',
                      '&rdquo;': '”',
                      '&amp;': '&',
                  }[m];
              })
            : '';
    }
}
